module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "form-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "welcome-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('login.welcome-text'))
    }
  }), _vm._v(" "), (_vm.formLogin) ? [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.$t('login.form-title')))]), _vm._v(" "), _c('form', {
    on: {
      "submit": _vm.submit
    }
  }, [(_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_c('p', [_vm._v(_vm._s(_vm.error.message))])]) : _vm._e(), _vm._v(" "), _c('ui-textbox', {
    staticClass: "dark",
    attrs: {
      "name": "username",
      "placeholder": _vm.$t('login.placeholder.username'),
      "disabled": _vm.isLoading,
      "required": true
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('ui-textbox', {
    staticClass: "dark",
    attrs: {
      "name": "password",
      "placeholder": _vm.$t('login.placeholder.password'),
      "disabled": _vm.isLoading,
      "required": true,
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('ui-button', {
    attrs: {
      "type": "normal",
      "button-type": "submit",
      "color": "primary",
      "raised": "",
      "loading": _vm.isLoading
    }
  }, [_vm._v(_vm._s(_vm.$t('login.button.submit')))]), _vm._v(" "), _c('a', {
    staticClass: "forgot-password-link",
    attrs: {
      "target": "_blank",
      "href": _vm.$t('login.forgot-password-url')
    }
  }, [_vm._v(_vm._s(_vm.$t('login.label.forgot-password')))])], 1)] : _c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    staticClass: "ui-button ui-button--type-normal ui-button--color-primary ui-button--icon-position-left ui-button--size-normal is-raised",
    attrs: {
      "href": _vm.B2BUrl + '/o/somfy/sso_login?redirect=ext_orderTracking'
    }
  }, [_c('div', {
    staticClass: "ui-button__content"
  }, [_vm._v(_vm._s(_vm.$t('login.button.submit')))])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    staticClass: "logo-image",
    attrs: {
      "src": require("assets/img/logo-somfy.svg"),
      "alt": "Logo Somfy"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-291869f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/PageLogin.vue
// module id = 293
// module chunks = 2